import React from "react";

const RingkasanEksekutifTJ = () => {
  return (
    <div style={{ width: "100%", height: "600px" }}>
      <iframe
        title="Data Transjakarta"
        src="https://datastudio.google.com/embed/reporting/fc76648f-68da-4e36-98c9-cf30a1b59d41/page/p_73wcqo3d3c"
        width="100%"
        height="100%"
        style={{
          border: 0,
          overflow: "hidden",
        }}
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default RingkasanEksekutifTJ;
